export default "__VITE_ASSET__3B0sQGEI__"